// JawMax — JS propio, vanilla, sin librerías externas.
document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initGaleriaProducto();
  initOpcionesProducto();
  initCantidad();
  initAcordeon();
  initResenasArrastre();
  initParallax();
});

function initParallax() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
  gsap.registerPlugin(ScrollTrigger);

  var imgs = document.querySelectorAll('.mt-parallax-img');
  imgs.forEach(function (img) {
    var esHero = img.hasAttribute('data-mt-parallax');
    var contenedor = esHero ? img.closest('.mt-hero-bleed') : img.parentElement;
    if (!contenedor) return;

    gsap.fromTo(
      img,
      { scale: 1 },
      {
        scale: esHero ? 1.14 : 1.16,
        ease: 'none',
        scrollTrigger: {
          trigger: contenedor,
          start: esHero ? 'top top' : 'top bottom',
          end: 'bottom top',
          scrub: true,
        },
      }
    );
  });
}

function initReveal() {
  var els = document.querySelectorAll('.mt-reveal');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var delay = entry.target.getAttribute('data-mt-delay') || 0;
          setTimeout(function () {
            entry.target.classList.add('mt-visible');
          }, parseInt(delay, 10));
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
  );
  els.forEach(function (el) { observer.observe(el); });
}

function initGaleriaProducto() {
  var principal = document.querySelector('[data-mt-galeria-principal]');
  var minis = document.querySelectorAll('[data-mt-mini]');
  if (!principal || !minis.length) return;
  var lista = Array.prototype.slice.call(minis);

  function activar(mini) {
    var src = mini.getAttribute('data-full');
    var alt = mini.getAttribute('data-alt') || '';
    principal.src = src;
    principal.alt = alt;
    lista.forEach(function (m) { m.classList.remove('is-active'); });
    mini.classList.add('is-active');
  }

  lista.forEach(function (mini) {
    mini.addEventListener('click', function () { activar(mini); });
  });

  function irA(delta) {
    var actual = lista.findIndex(function (m) { return m.classList.contains('is-active'); });
    if (actual === -1) actual = 0;
    var siguiente = (actual + delta + lista.length) % lista.length;
    activar(lista[siguiente]);
  }

  var prevBtn = document.querySelector('[data-mt-galeria-prev]');
  var nextBtn = document.querySelector('[data-mt-galeria-next]');
  if (prevBtn) prevBtn.addEventListener('click', function () { irA(-1); });
  if (nextBtn) nextBtn.addEventListener('click', function () { irA(1); });
}

function initOpcionesProducto() {
  var wrap = document.querySelector('[data-mt-producto-form]');
  if (!wrap) return;
  var dataEl = document.querySelector('[data-mt-variantes]');
  if (!dataEl) return;
  var variantes;
  try {
    variantes = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }
  var idInput = wrap.querySelector('input[name="id"]');
  var precioEl = document.querySelector('[data-mt-precio-actual]');
  var precioAnteriorEl = document.querySelector('[data-mt-precio-anterior]');
  var botonComprar = wrap.querySelector('[data-mt-boton-comprar]');
  var seleccion = {};

  document.querySelectorAll('[data-mt-opcion-valor]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var opcion = btn.getAttribute('data-opcion');
      var valor = btn.getAttribute('data-mt-opcion-valor');
      seleccion[opcion] = valor;
      document
        .querySelectorAll('[data-opcion="' + CSS.escape(opcion) + '"]')
        .forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
      actualizarVariante();
    });
  });

  function actualizarVariante() {
    var match = variantes.find(function (v) {
      return v.options.every(function (val, i) {
        var opciones = Object.values(seleccion);
        return opciones.includes(val);
      });
    });
    if (!match) return;
    idInput.value = match.id;
    if (precioEl) precioEl.textContent = formatoDinero(match.price);
    if (precioAnteriorEl) {
      if (match.compare_at_price && match.compare_at_price > match.price) {
        precioAnteriorEl.textContent = formatoDinero(match.compare_at_price);
        precioAnteriorEl.style.display = '';
      } else {
        precioAnteriorEl.style.display = 'none';
      }
    }
    if (botonComprar) {
      botonComprar.disabled = !match.available;
      botonComprar.textContent = match.available
        ? botonComprar.getAttribute('data-texto-disponible')
        : botonComprar.getAttribute('data-texto-agotado');
    }
  }

  function formatoDinero(centavos) {
    var moneda = document.querySelector('[data-mt-moneda]');
    var simbolo = moneda ? moneda.getAttribute('data-mt-moneda') : '€';
    return (centavos / 100).toFixed(2) + simbolo;
  }
}

function initCantidad() {
  var wrap = document.querySelector('[data-mt-cantidad]');
  if (!wrap) return;
  var input = wrap.querySelector('input');
  var menos = wrap.querySelector('[data-menos]');
  var mas = wrap.querySelector('[data-mas]');
  if (menos) menos.addEventListener('click', function () {
    var v = Math.max(1, parseInt(input.value || '1', 10) - 1);
    input.value = v;
  });
  if (mas) mas.addEventListener('click', function () {
    var v = parseInt(input.value || '1', 10) + 1;
    input.value = v;
  });
}

function initAcordeon() {
  document.querySelectorAll('[data-mt-acordeon-btn]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('.mt-producto-acordeon-item');
      var estabaAbierto = item.classList.contains('is-open');
      item.parentElement.querySelectorAll('.mt-producto-acordeon-item').forEach(function (i) {
        i.classList.remove('is-open');
      });
      if (!estabaAbierto) item.classList.add('is-open');
    });
  });
}

function initResenasArrastre() {
  var track = document.querySelector('[data-mt-resenas-track]');
  if (!track) return;
  var isDown = false;
  var startX, scrollLeft;
  track.addEventListener('mousedown', function (e) {
    isDown = true;
    startX = e.pageX - track.offsetLeft;
    scrollLeft = track.scrollLeft;
  });
  ['mouseleave', 'mouseup'].forEach(function (evt) {
    track.addEventListener(evt, function () { isDown = false; });
  });
  track.addEventListener('mousemove', function (e) {
    if (!isDown) return;
    e.preventDefault();
    var x = e.pageX - track.offsetLeft;
    track.scrollLeft = scrollLeft - (x - startX) * 1.2;
  });
}
